import TripRequestConfirmation from './trip-request-confirmation-container';

export default TripRequestConfirmation;
